import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';

export interface IPricingBlockCosts {
  displayName: string;
  min: number;
  max: number;
  currencyCode: string;
}
export interface IPricingBlockData {
  academicYear: string;
  costs: IPricingBlockCosts[];
}

export interface IPricingBlockContent {
  title: string;
  copyText?: string;
  studyLevel: string;
  costs: IPricingBlockData[];
}

export default class PricingBlockComponentModel extends BaseComponentModel {
  public component = 'PricingBlock';
  public pricingBlockContent: IPricingBlockContent;
  public appSettings: ApplicationSettings;

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = [];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  constructor(data: any, appSettings: ApplicationSettings) {
    super('pricingBlock', appSettings);

    const pricingBlockShouldReturn = this.shouldReturnEntity(data);

    if (!pricingBlockShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...pricingBlockShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.pricingBlockContent = {
      title: data?.title ?? 'Please add a title to this pricing block.',
      copyText: data?.copyText ?? null,
      studyLevel: data?.studyLevel ?? 'Please add a study level to this pricing block.',
      costs: data?.costs ?? [],
    };
    this.appSettings = appSettings;
  }
}
